
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";

    //import { Controlador as ControladorChat } from '@view/a-chat/controlador';
    import Notifications from "@env/shared/notifications/Notifications.vue";
    import YesNo from "@env/shared/modals/YesNo.vue";
    //import Chat from "@view/chat/embebido/chat.vue";
    import Menu from "./controles/Menu.vue";
    import Footer from "./controles/Footer.vue";
    import sinocancelar from "@env/shared/modals/SiNoCancelar.vue";
    import aceptar from "@env/shared/modals/Aceptar.vue";
    import imagen from "@env/shared/modals/Imagen.vue";
    //import chat_embebido from '@view/a-chat/embebido/chat.vue';
    import generando_archivo from '@com/a-interfaz/a-generando-archivo.vue';
    import nuevaversion from '@com/a-interfaz/a-nueva-version.vue';
    @Component( {
        name: "Template",
        props: {},
        components: {
            Footer,
            Menu,
            Notifications,
            YesNo,
            aceptar,
            imagen,
            nuevaversion,
            //Chat,
            sinocancelar,
            //chat_embebido,
            generando_archivo,

        }
    } )
    export default class Template extends Vue {

        constructor() {
            super();
        }

        public ChatEmbebido: boolean = false;
        public ChatAbierto: boolean = false;

        public async mounted()
        {
            this.$EventBus.$on( 'toolbar-titulo', (x:string) => { this.cambiarTitulo( x ); } );
            this.$EventBus.$on( 'toolbar-mostrar', () => { this.Barra = true; } );
            this.$EventBus.$on( 'toolbar-ocultar', () => { this.Barra = false; } );
            //ControladorChat.onChatEmbebido.subscribe( () => this.ChatEmbebido = ControladorChat.ChatEmbebido );

            this.Listo = true;
        }

        cambiarTitulo( titulo: string ) {
            this.Titulo = '';
            this.$nextTick( () => {
                this.Titulo = titulo;
            } )
        }

        public async destroy() {
            this.$socket.client.disconnect();
            this.$socket.client.close();
        }

        public Titulo: string = 'Inicio';
        public drawer: boolean = false;
        public Listo: boolean = false;
        public Barra: boolean = false;

        public get muestraMenu(): boolean {
            return !this.$vuetify.breakpoint.xsOnly && !this.$router.currentRoute.path.includes( 'chat' );
        }

        public atras() {
            this.Titulo = '';
            this.$router.back();
        }
    }
